import { SERVICE_NAME } from '@localstack/types';

import { PATH_PREFIX_RESOURCES } from './base';

const LAMBDA_BASE_ROUTE = `${PATH_PREFIX_RESOURCES}/${SERVICE_NAME.LAMBDA}`;

export const DEFAULT_LAMBDA_ROUTES: Record<string, string> = {
  RESOURCES_LAMBDA: `${LAMBDA_BASE_ROUTE}/`,
  RESOURCES_LAMBDA_FUNCTIONS: `${LAMBDA_BASE_ROUTE}/functions`,
  RESOURCES_LAMBDA_FUNCTION: `${LAMBDA_BASE_ROUTE}/functions/:name`,
  RESOURCES_LAMBDA_FUNCTION_INVOKE: `${LAMBDA_BASE_ROUTE}/functions/:name/invoke`,
  RESOURCES_LAMBDA_FUNCTION_UPDATE_CODE: `${LAMBDA_BASE_ROUTE}/functions/:name/update-code`,
  RESOURCES_LAMBDA_FUNCTION_NEW: `${LAMBDA_BASE_ROUTE}/functions/new`,
  RESOURCES_LAMBDA_FUNCTION_SCALING_CONFIG: `${LAMBDA_BASE_ROUTE}/functions/:name/scaling-config`,
  RESOURCES_LAMBDA_FUNCTION_SCALING_CONFIG_UPDATE: `${LAMBDA_BASE_ROUTE}/functions/:name/scaling-config/update`,
  RESOURCES_LAMBDA_LAYERS: `${LAMBDA_BASE_ROUTE}/layers`,
  RESOURCES_LAMBDA_LAYER_NEW: `${LAMBDA_BASE_ROUTE}/layers/new`,
  RESOURCES_LAMBDA_LAYER_VERSIONS: `${LAMBDA_BASE_ROUTE}/layers/:layer/versions`,
  RESOURCES_LAMBDA_CAPACITY_PROVIDERS: `${LAMBDA_BASE_ROUTE}/capacity-providers`,
  RESOURCES_LAMBDA_CAPACITY_PROVIDER: `${LAMBDA_BASE_ROUTE}/capacity-provider/:name`,
  RESOURCES_LAMBDA_CAPACITY_PROVIDER_FUNCTION_VERSIONS: `${LAMBDA_BASE_ROUTE}/capacity-provider/:name/function-versions`,
  RESOURCES_LAMBDA_CAPACITY_PROVIDER_NEW: `${LAMBDA_BASE_ROUTE}/capacity-providers/new`,
  RESOURCES_LAMBDA_CAPACITY_PROVIDER_UPDATE: `${LAMBDA_BASE_ROUTE}/capacity-providers/:name/update`,
  RESOURCES_LAMBDA_WEB_FUNCTIONS: `${LAMBDA_BASE_ROUTE}/web-functions`,
  RESOURCES_LAMBDA_WEB_FUNCTION_NEW: `${LAMBDA_BASE_ROUTE}/web-functions/new`,
  RESOURCES_LAMBDA_WEB_FUNCTION: `${LAMBDA_BASE_ROUTE}/web-functions/:name`,
  RESOURCES_LAMBDA_WEB_REVISION_NEW: `${LAMBDA_BASE_ROUTE}/web-functions/:name/revisions/new`,
  RESOURCES_LAMBDA_WEB_REVISIONS: `${LAMBDA_BASE_ROUTE}/web-functions/:name/revisions`,
  RESOURCES_LAMBDA_WEB_ENDPOINTS: `${LAMBDA_BASE_ROUTE}/web-functions/:name/endpoints`,
  RESOURCES_LAMBDA_WEB_ENDPOINT_NEW: `${LAMBDA_BASE_ROUTE}/web-functions/:name/endpoints/new`,
  RESOURCES_LAMBDA_WEB_ENDPOINT: `${LAMBDA_BASE_ROUTE}/web-functions/:name/endpoints/:endpointName`,
  RESOURCES_LAMBDA_WEB_ENDPOINT_UPDATE: `${LAMBDA_BASE_ROUTE}/web-functions/:name/endpoints/:endpointName/update`,
};
